<template>
  <ul class="kt-menu__nav">
    <template v-for="(menu, i) in menuItems">
      <KTMenuItem v-if="!menu.section" :menu="menu" :key="i"></KTMenuItem>
      <KTMenuSection v-if="menu.section" :menu="menu" :key="i"></KTMenuSection>
    </template>
  </ul>
</template>

<script>
import KTMenuItem from "@/views/theme/aside/MenuItem.vue";
import KTMenuSection from "@/views/theme/aside/MenuSection.vue";
import menuConfig from "@/common/config/menu.config.json";
import api from "@/common/api.service";

export default {
  name: "KTAsideMenu",
  components: {
    KTMenuItem,
    KTMenuSection,
  },
  mounted() {
    if (this.$store.state.auth.user.has_domains) {
      this.injectData();
    }
  },
  methods: {
    injectData: function () {
      api
        .query("zones")
        .then((response) => {
          let zones = response.data.zones;
          zones.sort((a, b) => {
            if (a.name < b.name) return -1;
            if (a.name > b.name) return 1;
            return 0;
          });
          this.dnsZones = zones;
        })
        .catch((error) => (this.errors = [error]))
        .finally(() => (this.loadingDns = false));
    },
  },
  data() {
    return {
      loadingDns: true,
      dnsZones: [],
      errors: [],
    };
  },
  computed: {
    menuItems() {
      let user = this.$store.state.auth.user;
      let asideItems = menuConfig.aside.items;
      let dnsZonesMenuIdx = asideItems.findIndex(
        (el) => el.title === "DNS Zones"
      );
      if (user.has_domains && dnsZonesMenuIdx > -1 && !this.loadingDns) {
        let dnsZonesMenuItem = {
          ...asideItems[dnsZonesMenuIdx],
          submenu: this.dnsZones.map(({ name, id }) => ({
            title: name,
            page: "dns_zones/" + id,
          })),
        };
        asideItems = [
          ...asideItems.slice(0, dnsZonesMenuIdx),
          dnsZonesMenuItem,
          ...asideItems.slice(dnsZonesMenuIdx + 1),
        ];
      }

      return asideItems.filter(
        (el) =>
          (el.section != "Analytics" || user.flows || user.has_metrics) &&
          (el.page != "flows" || user.flows) &&
          (el.page != "metrics" || user.has_metrics) &&
          (el.title != "DNS Zones" || user.has_domains) &&
          (el.page != "prefix_announcements" || user.can_announce_prefixes) &&
          (el.page != "signaling_sessions" || user.can_announce_prefixes) &&
          (el.page != "filters" || user.has_firewall) &&
          (el.page != "filter_configurations" || user.has_firewall) &&
          (el.page != "rate_limiters" || user.has_firewall) &&
          (el.page != "firewall_rules" || user.has_firewall) &&
          (el.section != "Web protection" || user.has_waf) &&
          (el.page != "websites" || user.has_waf) &&
          (el.page != "waf_rate_limiters" || user.has_waf) &&
          (el.page != "tls_certs" || user.has_waf) &&
          (el.page != "waf_flows" || user.has_waf)
      );
    },
  },
  watch: {
    "$store.state.auth.user.has_domains"() {
      if (this.$store.state.auth.user.has_domains) {
        this.injectData();
      }
    },
    dnsZones() {
      let dnsZonesObj = {};
      this.dnsZones.forEach((el) => {
        dnsZonesObj[el.id] = el.name;
      });
      this.$store.commit("setDnsZoneNames", dnsZonesObj);
    },
  },
};
</script>
